import { render } from "./FacebookIcon.vue?vue&type=template&id=2ac73bb2&ts=true"
import script from "./FacebookIcon.vue?vue&type=script&lang=ts"
export * from "./FacebookIcon.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/home/demon/projects/driven/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__